<template>
  <div class="h-100 w-100 overflow-y-scroll">
    <h1 class="tc textColor">{{$t("tracks.editTrack.title")}}</h1>
    <div class="flex justify-center">
      <router-link :to="{ name: 'track-new' }" replace
                    class="w4 bb bw1 ttu pa2 pointer flex justify-center items-center textColor no-underline link-primary">
        {{ $t('tracks.uploadTrack') }}
      </router-link>
      <router-link :to="{ name: 'new-album' }" replace
                    class="w4 bb bw1 ttu pa2 pointer flex justify-center items-center textColor no-underline link-primary">
        {{ $t('albums.uploadAlbum') }}
      </router-link>
    </div>
    <div class="mh6-l mh5-m mh3">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'new-track-wrapper',
  data () {
    return {
      routeName: 'new-track'
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/tracks/NewTrackWrapper.vue